import React from 'react';

/**
 * PageToolbar - Shared toolbar component for list pages
 * Contains: view toggle (table/cards), search box with optional scanner, filter slot
 *
 * Used by: Pallets, Wheels, Shipments, Items, Customers
 */
const PageToolbar = ({
  viewMode,
  onViewModeChange,
  searchTerm,
  searchPlaceholder = 'Search...',
  onSearchChange,
  showScanButton = false,
  onScan,
  children // Filter dropdowns passed as children
}) => {
  return (
    <div className="toolbar">
      {/* View Toggle */}
      <div className="view-toggle">
        <button
          className={`view-toggle-btn ${viewMode === 'table' ? 'active' : ''}`}
          onClick={() => onViewModeChange('table')}
          title="Table View"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <rect x="1" y="3" width="14" height="2" />
            <rect x="1" y="7" width="14" height="2" />
            <rect x="1" y="11" width="14" height="2" />
          </svg>
        </button>
        <button
          className={`view-toggle-btn ${viewMode === 'cards' ? 'active' : ''}`}
          onClick={() => onViewModeChange('cards')}
          title="Card View"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <rect x="1" y="1" width="6" height="6" />
            <rect x="9" y="1" width="6" height="6" />
            <rect x="1" y="9" width="6" height="6" />
            <rect x="9" y="9" width="6" height="6" />
          </svg>
        </button>
      </div>

      {/* Search Box */}
      <div className="search-box">
        <svg className="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="11" cy="11" r="8"/>
          <path d="M21 21l-4.35-4.35"/>
        </svg>
        <input
          type="text"
          placeholder={searchPlaceholder}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        {showScanButton && (
          <button className="scan-btn" onClick={onScan} title="Scan barcode">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M2 4h2v16H2V4zm4 0h1v16H6V4zm3 0h2v16H9V4zm4 0h1v16h-1V4zm3 0h1v16h-1V4zm3 0h2v16h-2V4z"/>
            </svg>
          </button>
        )}
      </div>

      {/* Filters - passed as children for flexibility */}
      {children && (
        <div className="toolbar-filters">
          {children}
        </div>
      )}
    </div>
  );
};

export default PageToolbar;
